var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var ScoreRowCells = /** @class */ (function (_super) {
    __extends(ScoreRowCells, _super);
    function ScoreRowCells() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScoreRowCells.prototype.render = function () {
        var _this = this;
        return (this.props.displayedInnings.map(function (displayedInning, index) {
            var score = (_this.props.scores.length > index && _this.props.scores[index] !== undefined)
                ? _this.props.scores[index] : "-";
            return (React.createElement("td", { className: "rj-baseball-scoreboard-score-cell", key: _this.props.rowCellkey + "-inning-" + index }, score));
        }));
    };
    return ScoreRowCells;
}(React.PureComponent));
export { ScoreRowCells };
//# sourceMappingURL=ScoreRowCells.js.map